import React from 'react'
import ReactDOM from 'react-dom'
import Root from 'containers/Root.js'
import { isVisManager } from 'utils/visManager'
import { datadogLogs } from '@datadog/browser-logs'

datadogLogs.init({
  clientToken: process.env.DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: 'gvc',
  env: process.env.DATADOG_ENV,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  beforeSend: (log) => {
    if (log.status === 'error' && log.message) {
      const prefix = isVisManager() ? 'VisMgr' : 'VisNow'
      log.message = `[${prefix}] ${log.message}`
    }
  }
})

ReactDOM.render(
  <Root />,
  document.getElementById('root')
)
